// NotiBrd.js

import { useState, useEffect, useRef, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/CommonCtx';
import axios from 'axios';
//import moment from 'moment';
//import 'react-tabulator/lib/styles.css';
//import 'react-tabulator/lib/css/tabulator.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_bootstrap3.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_bootstrap4.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_bulma.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_materialize.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_midnight.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_modern.min.css'; // theme
import 'react-tabulator/lib/css/tabulator_semanticui.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_simple.min.css'; // theme
//import 'react-tabulator/lib/css/tabulator_site.min.css'; // theme
import { ReactTabulator } from 'react-tabulator';
//import { TabulatorFull } from 'tabulator-tables';
//import 'tabulator-tables/dist/css/tabulator.min.css';
//import PulseLoader from 'react-spinners/PulseLoader';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
//import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
//import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import InputLabel from '@mui/material/InputLabel';
//import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
//import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
//import Modal from '@mui/material/Modal';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
//import DialogActions from '@mui/material/DialogActions';
import BottomNavigation from '@mui/material/BottomNavigation';

//const luxon = require('luxon');
//window.datetime = luxon.datetime;

const NotiBrd = (props) => {
    //console.log('pano_props', props);
   
    // loading
    const [ loading, setLoading ] = useState(false);

    // snackbar
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
   
    // selected tab
    const [ tab, setTab ] = useState('1');

    // common context
    const { user, ml, ppms, port } = useAuth();

    // tabs element
    const elTabs = useRef(null);

    // grid lang
    const gridLang = useRef('');
    const gridLangs = useRef({});

    // tabulator
    const sizeList = [ 10, 25, 50, 100 ];
    const sizeLatest = useRef(10);

    //const elTable = useRef(null);
    const gridTable = useRef(null);
    const [ height, setHeight ] = useState('100%');
    //const [ page, setPage ] = useState(1);
    const [ size, setSize ] = useState(10);
    const [ tableKey, setTableKey ] = useState(`${Math.random()}`);
    //setTableKey(`${Math.random()}`), <ReactTabulator key={tableKey} ref={tableRef} 

    // all project list
    //const projs = useRef([]);
    // selected project
    //const [ proj, setProj ] = useState('');

    // notice content
    const notiTitleRef = useRef(null);
    //const notiProjRef = useRef(null);
    const [ notiProj, setNotiProj ] = useState('');
    const [ notiTitle, setNotiTitle ] = useState('');
    const [ notiContent, setNotiContent ] = useState('');

    // notice list
    const [ notiList, setNotiList ] = useState([]);

    // table
    const notiCols = [
        //{ formatter: 'responsiveCollapse', width:40, minWidth: 40, hozAlign:"center", resizable:false, headerSort:false },
        //{ title: ml.BOARD_NO, field: 'num', width: 80, print: true, download: true, clipboard: true, formatter: 'rownum' },
        { title: ml.BOARD_TITLE, field: 'title', resizable: true, responsive: 0 },
        //{ title: ml.BOARD_PROJ, field: 'proj_nm', /*width: 200,*/ resizable: true },
        //{ title: ml.BOARD_USER, field: 'real_name', width: 100, resizable: true },
        { title: ml.BOARD_DATE, field: 'rdate', /*width: 150,*/ resizable: true },
        //{ title: ml.BOARD_DATE, field: 'rdate', /*width: 150,*/ resizable: true, formatter: function(cell, params, onRendered) { return cell.getValue().split(' ')[0]; }},
    ];

    const setGridLang = useCallback(() => {
        //let gridLang = 'en-us';
        //let gridLang = 'default';

        if (ml.LANG === 'ko') {
            gridLang.current = 'ko-kr';
        } else {
            gridLang.current = 'default';
        };

        gridLangs.current = {};
        gridLangs.current[gridLang.current] = {
            'pagination': {
                'first': '|<',
                'last': '>|',
                'prev': '<',
                'next': '>',
                'first_title': ml.PAGE_FIRST,
                'last_title': ml.PAGE_LAST,
                'prev_title': ml.PAGE_PREV,
                'next_title': ml.PAGE_NEXT,
                'page_title': ml.PAGE,
                'counter': {
                    'showing': '',
                    'of': '/',
                    'rows': '',
                    'pages': '',
                }
            }
        }
    }, [ ml.LANG, ml.PAGE_FIRST, ml.PAGE_LAST, ml.PAGE_PREV, ml.PAGE_NEXT, ml.PAGE ]);

    const setGridHeight = () => {
        let h = document.body.clientHeight - 199; //162;
        //console.log('h', h, document.body.clientHeight);
        setHeight(h);
        setTableKey(`${Math.random()}`);
    };

    const gridOptions = {
        /*
        responsiveLayout: true,
        //responsiveLayout: 'hide',
        //responsiveLayout: 'collapse',
        //responsiveLayoutCollapseStartOpen: false,
        responsiveLayoutCollapseFormatter: function(data) {
            //data - an array of objects containing the column title and value for each cell
            //let list = document.createElement('ul');
            let list = document.createElement('div');

            data.forEach(function(col){
                //let item = document.createElement('li');
                let item = document.createElement('div');
                //item.innerHTML = "<strong>" + col.title + "</strong> - " + col.value;
                item.innerHTML = col.value;
                list.appendChild(item);
            });

            return Object.keys(data).length ? list : "";
        },
        */
        height: height, //'calc(100% - 162px)',
        maxHeight: height, //'calc(100% - 162px)',
        rowHeight: 40,
        groupBy: 'proj_nm',
        headerVisible: false, // hide column headers
        layoutColumnsOnNewData: true,
        //pagination: true,
        //paginationMode: 'remote',
        //paginationSize: size,
        //paginationCounter: 'rows',
        //ajaxURL: `${ppms}:${port}/appms/bdlist`,
        //ajaxParams: { bid: 'notice', timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
        //dataSendParams:{ "size": "count", },
        //paginationCounterElement: '#board-pagecounter',
        //locale: true,
        locale: gridLang.current,
        langs: gridLangs.current,
        //placeholder: 'No data',
        addRowPos: 'bottom',
        //selectable: 1,
        /*
        footerElement: `
            <span>
                <!--
                <a href="#" id="board-row-filter" class="btn btn-sm bg-transparent text-primary" aria-checked="false" style="border: none;" role="button" title="${ml.              ROW_FILTER}" onclick="filterBoardRow(this);">
                    <span class="material-icons align-middle" style="font-size: 20px; cursor: pointer;">filter_alt</span>
                </a>
                -->
                <span id="board-pagecounter" class="bg-transparent text-primary text-center align-middle" style="margin-left: 20px; border: none; font-family: 'Anton', sans-serif;">
                </span>
            </span>
        `,
        */
        //autoColumns: true,
        columnDefaults: {
            //resizable: true,
            hozAlign: 'left',
            headerHozAlign: 'left',
            headerSort: false,
            //width: 100,
            minWidth: 40,
        },
        //reactiveData: true, //enable data reactivity
        //data: notiList,
        //columns: notiCols
    };

    //const initGrid = () => {
        //gridTable.current = new TabulatorFull(elTable.current, gridOptions);
    //};

    const rowClick = async(e, row) => {
        let r = row.getData();

        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            //console.log(timezone);

            const data = new URLSearchParams({
                bid: 'notice',
                bno: r.no,
                page: '',
                count: '',
                timezone: timezone
            });
            //console.log('data', data);

            const res = await axios.post(`${ppms}:${port}/appms/bdlist`, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('bdlist', res);

            if (res.data !== null && res.data.length > 0) {
                //console.log('res', res.data[0]);

                setNotiTitle(r.title);
                setNotiProj(r.proj_nm);
                setNotiContent(res.data[0].content);
                handleOpen();
            } else {
            };
        } catch (err) {
            console.log(err);
        }
    };

    const getNotiList = useCallback(async() => {
        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            //console.log(timezone);

            const data = new URLSearchParams({
                bid: 'notice',
                page: 1, //page,
                count: sizeLatest.current, //size,
                timezone: timezone
            });
            // bno: '',
            //console.log('data', data);

            const res = await axios.post(`${ppms}:${port}/appms/bdlist`, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('bdlist', res);

            if (res.data !== null && res.data.length > 0) {
                setNotiList(res.data);
                setGridHeight();
                //gridTable.current.setData(res.data);
            } else {
                setNotiList([]);
                setGridHeight();
                //gridTable.current.setData([]);
            };
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    /*
    const getProjects = useCallback(async() => {
        try {
            const url = `${ppms}:${port}/appms/projs`;
            const res = await axios.get(url, { withCredentials: true });
            //console.log('projs_res', res);
            projs.current = res.data;
            if (res.data.length > 0) {
                //setProj(res.data[0].proj_cd);
                //setProj(res.data[0].proj_id);
                return res.data[0].proj_id;
            } else {
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);
    */

    const handleChangeTab = (e, newValue) => {
        setTab(newValue);

        if (elTabs.current !== null) {
            //elTabs.current.setAttribute('data-tab', newValue);
        };

        if (newValue === '1') {
        };
    };

    //const handlePageChange = (e, page) => {
    //    setPage(page);
    //};

    //const handleSizeChange = (e, size) => {
    //    setSize(size);
    //};

    const handleNotiSize = (e) => {
        setSize(e.target.value);
        sizeLatest.current = e.target.value;

        getNotiList();
    };

    useEffect(() => {
        (async() => {
            setGridLang();
            setGridHeight();

            //initGrid();
            getNotiList();

            //let pid = await getProjects();
            //setProj(pid);

            if (elTabs.current !== null) {
                //elTabs.current.setAttribute('data-tab', '1');
            };
        })();

        return () => {
            //console.log('unmount');
        };
    }, [ setGridLang, gridTable, getNotiList ]);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') return;
        setSuccess(false);
    };
    const handleCloseFailed = (event, reason) => {
        if (reason === 'clickaway') return;
        setFailed(false);
    };

    const handleOpen = () => {
        setLoading(true);
    };

    const handleClose = () => {
        setLoading(false);
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    const ContainerPics = styled(Container)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        //alignItems: 'center',
        //justifyContent: 'center',
        background: '#f0f8ff',
        //background: theme.palette.grey[50],
    }));
    /*
    const BoxProj = styled(Box)(({theme}) => ({
        display: 'flex',
        //flexDirection: 'column',
        //flexGrow: 1,
        //flexDirection: {
        //    xs: 'column', // mobile
        //    sm: 'row', // tablet and up
        //},
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        //borderRadius: 10,
        //background: theme.palette.white,
        //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    */
    /*
    const BoxImg = styled(Box)(({theme}) => ({
        //display: 'none',
        display: 'flex',
        width: '100%',
        height: '40vh',
        //backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
        //backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        //backgroundColor: '#ffffff', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        borderRadius: 5,
        borderColor : '#e0e0e0',
        borderWidth: '1px',
        borderStyle: 'solid',
    }));
    */
    
    return (
        <ContainerPics maxWidth={false} disableGutters sx={{ m:0, p:0, width: '100%', flexGrow: 1 }}>
            <Toolbar />
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs variant="fullWidth" value={tab} data-tab={tab} ref={elTabs} onChange={handleChangeTab}>
                    <Tab label={ml.NOTICE_BOARD} value="1" id="tab-360-1" aria-controls="tabpanel-360-1" sx={{ fontSize: 'min(16px, 3.6vmin)', fontWeight: 'bold' }} />
                </Tabs>
            </Box>
            <div role="tabpanel" hidden={tab !== '1'} id="tabpanel-360-1" aria-labelledby="tab-360-1" value="1" sx={{ p: 0 }}>
                <Box sx={{ m: 0, p: 0 }}>
                    <Box sx={{ m: 0, width: '100%' }}>
                        <FormControl variant="standard" sx={{ mx: 0, my: 0.5, p: 0, width: '80%' }} size="small" fullWidth>
                            <Select id="noti-latest" value={size} onChange={handleNotiSize} sx={{ m: 0, p: 0, color: '#1976d2', bgcolor: 'transparent' }}>
                                { sizeList.map((s, idx) => (
                                    <MenuItem key={s} value={s} dense sx={{ color: '#1976d2' }}>
                                        <Typography textAlign="center" variant="subtitle2">{ml.LATEST + ' ' + s}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    {/* <div ref={elTable} /> */}
                    {/* onRef={(r) => (gridTable.current[1] = r.current)} layout={notiList.length > 0 ? 'fitDataFill' : 'fitColumns'} size="medium" */}
                    <ReactTabulator key={tableKey} onRef={(r) => {gridTable.current = r.current;}} data={notiList} columns={notiCols} layout={'fitColumns'} options={gridOptions} 
                        style={{ margin: 0, padding: 0 }} events={{ rowClick: rowClick }} 
                    />
                    {/*
                        page={page} size={size}
                    <Pagination page={page} size="medium" total={notiList.length} onPageChange={handlePageChange} onSizeChange={handleSizeChange} />
                    */}
                </Box>
            </div>
            <Snackbar open={success} autoHideDuration={3000} onClose={handleCloseSuccess} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Successfully completed!
                </Alert>
            </Snackbar>
            <Snackbar open={failed} autoHideDuration={3000} onClose={handleCloseFailed} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseFailed} severity="error" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Failed!
                </Alert>
            </Snackbar>
            <BootstrapDialog fullScreen open={loading} onClose={handleClose}>
                <DialogTitle sx={{ m: 0, p: 1, color: '#ffffff', bgcolor: (theme) => theme.palette.primary.main }} id="noti-dialog-title">
                    {notiProj}
                </DialogTitle>
                <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[200] }}>
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers sx={{ bgcolor: (theme) => theme.palette.grey[50] }} >
                    <TextField variant="standard" size="small" margin="dense" required fullWidth id="noti-title" name="NotiTitle" 
                        ref={notiTitleRef} inputProps={{ readOnly: true, style: { color: '#1976d2' } }} value={notiTitle} sx={{ display: 'block', my: 1 }}
                    />
                    {/*
                    <TextField variant="outlined" size="small" margin="dense" required fullWidth id="noti-proj" label={ml.PROJECT} name="NotiProj" 
                        ref={notiProjRef} inputProps={{ readOnly: true }} value={notiProj} sx={{ display: 'block' }}
                    />
                    */}
                    <Box dangerouslySetInnerHTML={{__html: notiContent}}
                        sx={{ bgcolor: 'background.paper', boxShadow: 1, borderRadius: 2, p: 2, width: '100%', height: 'calc(100% - 50px)' }}
                    />
                </DialogContent>
            </BootstrapDialog>
            <BottomNavigation value="" sx={{ display: 'block', minHeight: '56px', background: 'none' }} />
        </ContainerPics>
    );
};

export default NotiBrd;


